/* eslint-disable no-bitwise */
export const hexToRgbA = (hex: string, opacity?: number) => {
  let c: any;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');

    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + `,${opacity ?? 1})`;
  }

  console.warn(`Bad Hex: ${hex}`);
  return hex;
};

export const hexToGray = (hex: string) => {
  let c: any;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');

    const r = (c >> 16) & 255;
    const g = (c >> 8) & 255;
    const b = c & 255;

    const gray = Math.round(0.2126 * r + 0.7152 * g + 0.0722 * b);

    return `rgb(${gray},${gray},${gray})`;
  }

  console.warn(`Bad Hex: ${hex}`);
  return hex;
};
